var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C5.28595 20 2.92893 20 1.46447 18.5355C0 17.0711 0 14.714 0 10C0 5.28595 0 2.92893 1.46447 1.46447C2.92893 0 5.28595 0 10 0C14.714 0 17.0711 0 18.5355 1.46447C20 2.92893 20 5.28595 20 10C20 14.714 20 17.0711 18.5355 18.5355C17.0711 20 14.714 20 10 20ZM11.9563 12.0951C11.7631 12.2646 11.5168 12.3631 11.0241 12.5602C8.71431 13.4841 7.55942 13.9461 6.89976 13.4978C6.74336 13.3915 6.60846 13.2566 6.50218 13.1002C6.05392 12.4406 6.51587 11.2857 7.43979 8.97591C7.63685 8.48324 7.73539 8.23691 7.90486 8.04365C7.94804 7.99441 7.99441 7.94804 8.04365 7.90486C8.23691 7.73539 8.48324 7.63685 8.97591 7.43979C11.2857 6.51587 12.4406 6.05392 13.1002 6.50218C13.2566 6.60846 13.3915 6.74336 13.4978 6.89976C13.9461 7.55942 13.4841 8.71431 12.5602 11.0241C12.3631 11.5168 12.2646 11.7631 12.0951 11.9563C12.052 12.0056 12.0056 12.052 11.9563 12.0951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination);
export default __webpack_public_path__ + "static/media/destination.5ace9ad1d97d50efbf344d233a9d2817.svg";
export { ForwardRef as ReactComponent };